export default __webpack_public_path__ + "static/media/bag.21ea1b59.svg";